"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var WidgetMenuButton_1 = __importDefault(require("../WidgetMenuButton"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var TokenMenu_1 = require("../TokenMenu/TokenMenu");
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
var SubstitutionTokenFactory_1 = __importDefault(require("Tokens/SubstitutionTokenFactory"));
var EmbedWidgetMenu = (function (_super) {
    __extends(EmbedWidgetMenu, _super);
    function EmbedWidgetMenu(props) {
        var _this = this;
        var _a;
        _this = _super.call(this, props) || this;
        _this.showTokenMenu = false;
        _this.confirmToken = function (token) {
            var _a;
            (_a = _this.props.tokenUtilities) === null || _a === void 0 ? void 0 : _a.confirmToken({
                name: token.apiName,
                label: token.name,
                substitutionToken: SubstitutionTokenFactory_1.default.fromLegacyApiToken(token),
            });
        };
        _this.removeToken = function () {
            var _a;
            _this.showTokenMenu = false;
            (_a = _this.props.tokenUtilities) === null || _a === void 0 ? void 0 : _a.removeToken();
        };
        _this.handleOnChange = function (value) {
            _this.displayUrl = value;
        };
        _this.handleKeyDown = function (event) {
            if (event.key === kaleidoscope_3.KeyType.Enter) {
                _this.updateUrl();
            }
        };
        _this.updateUrl = function () {
            _this.props.handleDisplayUrlChange(_this.displayUrl);
        };
        _this.onClickTokenButton = function () {
            var _a;
            if (_this.hasToken) {
                (_a = _this.props.tokenUtilities) === null || _a === void 0 ? void 0 : _a.removeToken();
            }
            else {
                _this.showTokenMenu = true;
            }
        };
        _this.displayUrl = props.displayUrl || "";
        _this.showTokenMenu = !!((_a = props.tokenUtilities) === null || _a === void 0 ? void 0 : _a.token);
        return _this;
    }
    EmbedWidgetMenu.prototype.render = function () {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)({
                "embed-widget__embed-controls-holder": true,
                "embed-widget__embed-controls-holder--show-menu": this.props.showMenu,
            }), "data-slate-editor": true, contentEditable: false },
            react_1.default.createElement(kaleidoscope_2.ErrorTooltip, { size: kaleidoscope_1.TooltipSize.Large, content: this.props.errorMsg, renderTooltip: this.props.showError || false },
                react_1.default.createElement("div", { className: "editor-toolbar" },
                    !this.showTokenMenu && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "link-input" },
                            react_1.default.createElement(kaleidoscope_3.TextInput, { label: this.props.placeholderText, placeholder: this.props.placeholderText, labelHidden: true, theme: kaleidoscope_3.TextInputTheme.Dark, variant: kaleidoscope_3.TextInputVariant.Borderless, value: this.displayUrl, onChange: this.handleOnChange, onKeyDown: this.handleKeyDown, size: kaleidoscope_3.TextInputSize.XSmall })),
                        react_1.default.createElement(WidgetMenuButton_1.default, { icon: react_1.default.createElement(icons_1.Tick, null), customClass: "embed-widget__tick-button", onMouseDown: this.updateUrl }))),
                    this.showTokenMenu && this.renderTokenMenu(),
                    this.isUsingTokens && !this.showTokenMenu && (react_1.default.createElement(WidgetMenuButton_1.default, { icon: this.hasToken ? react_1.default.createElement(icons_1.RemoveToken, null) : react_1.default.createElement(icons_1.Tokens, null), onMouseDown: this.onClickTokenButton })),
                    react_1.default.createElement(WidgetMenuButton_1.default, { icon: react_1.default.createElement(icons_1.Delete, null), customClass: "embed-widget__delete-button", onMouseDown: this.props.handleDelete, isDestructive: true })))));
    };
    EmbedWidgetMenu.prototype.renderTokenMenu = function () {
        if (this.props.tokenUtilities == undefined) {
            return null;
        }
        var _a = this.props.tokenUtilities, confirmToken = _a.confirmToken, token = _a.token;
        return (react_1.default.createElement("div", { className: "embed-widget__combo-holder" },
            react_1.default.createElement(TokenMenu_1.TokenMenu, { type: Types_1.TokenDataType.String, token: token, removeToken: this.removeToken, confirmToken: this.confirmToken })));
    };
    Object.defineProperty(EmbedWidgetMenu.prototype, "isUsingTokens", {
        get: function () {
            return this.props.tokenUtilities != undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedWidgetMenu.prototype, "hasToken", {
        get: function () {
            var _a;
            return ((_a = this.props.tokenUtilities) === null || _a === void 0 ? void 0 : _a.token) != undefined;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], EmbedWidgetMenu.prototype, "displayUrl", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], EmbedWidgetMenu.prototype, "showTokenMenu", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], EmbedWidgetMenu.prototype, "removeToken", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], EmbedWidgetMenu.prototype, "handleOnChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], EmbedWidgetMenu.prototype, "handleKeyDown", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], EmbedWidgetMenu.prototype, "onClickTokenButton", void 0);
    EmbedWidgetMenu = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], EmbedWidgetMenu);
    return EmbedWidgetMenu;
}(react_1.default.Component));
exports.default = EmbedWidgetMenu;
